// UKU-2600 metrics
export const uku_get_param = function (name) {
    const urlParams = new URLSearchParams(location.search)
    return urlParams.get(name)
}
export const uku_get_domain = function (url) {
    if (url == null) url = window.location
    let hostname = (new URL(url)).hostname
    let domain = hostname.replace('www.', '')
    let a = domain.split('.')
    return a.length >= 2 ? (a[a.length - 2] + '.' + a[a.length - 1]) : domain
}
export const uku_set_cookie = function (name, value, days, path) {
    const secure = 'Secure'
    const samesite = 'None'
    const domain = uku_get_domain()

    path = path == null ? "/" : path

    let expires = ""
    if (days) {
        let date = new Date()
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
        expires = date.toGMTString()
    }

    const cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value)
        + "; " + secure
        + "; samesite=" + samesite
        + "; domain=" + domain
        + "; path=" + path
        + "; expires=" + expires;
    //if (value) console.info('SET COOKIE', cookie)
    document.cookie = cookie
    return true
}
export const uku_set_utm_cookies = function (info) {
    const utm_source = uku_get_param('utm_source') || ''
    if (utm_source.length) {
        // if source is set then overwrite all even when empty
        uku_set_cookie('utm_source', utm_source, 365)
        uku_set_cookie('utm_medium', uku_get_param('utm_medium') || '', 365)
        uku_set_cookie('utm_campaign', uku_get_param('utm_campaign') || '', 365)
        uku_set_cookie('utm_term', uku_get_param('utm_term') || '', 365)
        uku_set_cookie('utm_content', uku_get_param('utm_content') || '', 365)
        // console.info('uku_set_utm_cookies :: ' + (info || '') + ' :: utm_source = "' + utm_source)
    }
}

export const UKU_ACTIVITIES = {
    GENERATE_LEAD: "generate_lead",
    SIGN_UP: "sign_up",
    LAST_SEEN: "last_seen",
    ACTIVE_USER: "active_user",
    INVITE_SENT: "invite_sent",
    INVITE_OPENED: "invite_opened",
    INVITE_ACCEPTED: 'invite_accepted',

    BEGIN_BOOKING: "begin_booking",
    DEMO_BOOKED: "demo_booked",
    DEMO_COMPLETED: "demo_completed",
    WEBINAR_BOOKED: "webinar_booked",
    EBOOK_DOWNLOADED: "ebook_downloaded",
    CONTENT_VIEWED: "content_viewed",

    TUTORIAL_BEGIN: "tutorial_begin",
    TUTORIAL_COMPLETE: "tutorial_complete",
    COMPANY_CREATED: "company_created",
    COMPANY_DELETED: "company_deleted",
    CHURN_TRIAL: "churn_trial",

    VIEW_CART: "view_cart",
    ADD_TO_CART: "add_to_cart",
    BEGIN_CHECKOUT: "begin_checkout",
    PURCHASE: "purchase",
    PURCHASE_FAILED: "purchase_failed",
    SUBSCRIPTION_CANCELLED: "subscription_cancelled",
    ACCOUNT_DELETED: "account_deleted",
    CHURN_PAID: "churn_paid",

    // intercom events
    ADDED_TASK: "added_task",
    ADDED_CLIENT: "added_client",
    CUSTOM_FIELD_ACTIVATED: "custom_field_activated",
}

export const uku_get_cookie = function (name) {
    let match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
    return match ? decodeURIComponent(match[3]) : null;
};

export const uku_set_user_cookies = function (uku_user_id, uku_lead_id, uku_person_id, uku_em, info) {
    // overwrite only if user logged in
    if (uku_user_id) {
        uku_set_cookie("userId", uku_user_id, 365)
        uku_set_cookie("uku_user_id", uku_user_id, 365)
        uku_set_cookie("uku_lead_id", uku_lead_id, 365)
        uku_set_cookie("uku_person_id", uku_person_id, 365)
        uku_set_cookie("uku_em", uku_em, 365)
        // console.info('uku_set :: ' + (info || '') + ' :: uku_user_id = "' + uku_user_id + '"')
    }
}

export const uku_reset_cookies = function (info) {
    // reset app
    window.userId = null
    window.uku_user_id = null
    window.uku_lead_id = null
    window.uku_person_id = null
    window.uku_em = null
    // reset uku cookies
    uku_set_cookie('userId', 0, -365)
    uku_set_cookie('uku_user_id', 0, -365)
    uku_set_cookie('uku_lead_id', 0, -365)
    uku_set_cookie('uku_person_id', 0, -365)
    uku_set_cookie('uku_em', '', -365)
    // reset utm cookies
    uku_set_cookie('utm_source', '', -365)
    uku_set_cookie('utm_medium', '', -365)
    uku_set_cookie('utm_campaign', '', -365)
    uku_set_cookie('utm_term', '', -365)
    uku_set_cookie('utm_content', '', -365)
}

export const uku_send_event = async function (payload) {
    if (window.uku_no_track) {
        console.warn('uku_activity :: incognito :: ' + payload.info)
        return
    }
    // init
    let skip_intercom = 'skip_intercom' in payload && payload['skip_intercom']
    let skip_uku = 'skip_uku' in payload && payload['skip_uku']
    let skip_ga = 'skip_ga' in payload && payload['skip_ga']
    let skip_fb = 'skip_fb' in payload && payload['skip_fb']
    let skip_li = 'skip_li' in payload && payload['skip_li']
    let allow
    let ignore

    // setup cookies
    try {
        // user cookies
        payload['uku_user_id'] = uku_get_cookie("uku_user_id") || window.uku_user_id
        payload['uku_lead_id'] = uku_get_cookie("uku_lead_id") || window.uku_lead_id
        payload['uku_person_id'] = uku_get_cookie("uku_person_id") || window.uku_person_id
        payload['uku_em'] = uku_get_cookie("uku_em") || window.uku_em
        // utm cookies
        if (uku_get_cookie("utm_source")) {
            payload['utm_source'] = uku_get_cookie("utm_source")
            payload['utm_medium'] = uku_get_cookie("utm_medium")
            payload['utm_campaign'] = uku_get_cookie("utm_campaign")
            payload['utm_term'] = uku_get_cookie("utm_term")
            payload['utm_content'] = uku_get_cookie("utm_content")
        }
    } catch (ex) {
        console.error('uku_activity :: ' + payload.info, ex)
    }

    // Uku events
    try {
        ignore = payload.event === UKU_ACTIVITIES.ADDED_CLIENT || payload.event === UKU_ACTIVITIES.ADDED_TASK || payload.event === UKU_ACTIVITIES.CUSTOM_FIELD_ACTIVATED
        if (window.uku_activity_url && payload.uku_user_id && !skip_uku && !ignore) {
            let xhr = new XMLHttpRequest();
            xhr.open("POST", window.uku_activity_url, true);
            xhr.setRequestHeader("X-XSRFToken", uku_get_cookie("_xsrf"));
            xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            xhr.setRequestHeader("Accept", "application/json, text/plain, */*");
            xhr.withCredentials = true;
            xhr.send(JSON.stringify(payload));
            // console.info('uku_activity UKU :: ' + payload.info);
        }
    } catch (ex) {
        console.error('uku_activity :: ' + payload.info, ex)
    }

    // obfuscate
    try {
        for (let k in ["email", "name", "phone"]) if (k in payload) delete payload[k]
    } catch (ex) {
        console.error('uku_activity obfuscate', ex)
    }

    // Intercom events
    try {
        allow = true;
        if (!skip_intercom && window.Intercom && allow) {
            window.Intercom("trackEvent", payload.event)
            // console.info('uku_activity IC :: ' + payload.event)
        }
    } catch (ex) {
        console.error('uku_activity IC :: ' + payload.info, ex)
    }

    // GA events
    try {
        allow = true
        if (!skip_ga && window.gtag && allow) {
            const gaPayload = payload.uku_user_id ? {'user_id': payload.uku_user_id} : {}
            window.gtag('event', payload.event, gaPayload)
            // console.info('uku_activity GA :: ' + payload.event)
            // future :: replace "active_user" with "last_seen"
            if (payload.event === UKU_ACTIVITIES.LAST_SEEN) window.gtag('event', UKU_ACTIVITIES.ACTIVE_USER, gaPayload)
        }
    } catch (ex) {
        console.error('uku_activity GA :: ' + payload.info, ex)
    }

    // FB events
    try {
        // payload.event === UKU_ACTIVITIES.GENERATE_LEAD || payload.event === UKU_ACTIVITIES.SIGN_UP || payload.event === UKU_ACTIVITIES.PURCHASE
        allow = true
        if (!skip_fb && window.fbq && allow) {
            const fbqPayload = payload.uku_user_id ? {'external_id': payload.uku_user_id, 'em': payload.uku_em} : {}
            window.fbq('track', payload.event, fbqPayload)
            // console.info('uku_activity FB :: ' + payload.event)
            // future :: replace "active_user" with "last_seen"
            if (payload.event === UKU_ACTIVITIES.LAST_SEEN) window.fbq('track', UKU_ACTIVITIES.ACTIVE_USER, fbqPayload)
        }
    } catch (ex) {
        console.error('uku_activity FB :: ' + payload.info, ex)
    }

    // Linkedin events
    try {
        allow = true
        if (!skip_li && window.lintrk && allow) {
            let liPayload = {}
            liPayload.event = payload.event
            if (payload.event === UKU_ACTIVITIES.GENERATE_LEAD || payload.event === UKU_ACTIVITIES.SIGN_UP) {
                if (window.linkedin_conversion_id) {
                    liPayload.conversion_id = window.linkedin_conversion_id
                }
            }
            window.lintrk('track', liPayload)
            // console.info('uku_activity LI', liPayload)
        }
    } catch (ex) {
        console.error('uku_activity LI :: ' + payload.info, ex)
    }
}
